import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  modalContainer: {
    backgroundColor: `${theme.palette.common.modal} !important`,
  },
}));
